module.exports = __webpack_public_path__ + "img/err-icon.737483c3.jpeg";